import React from "react";

const MainComponent = props=> {
    const {children, isIframe, bgColor} = props;

    return <div style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        minHeight: isIframe ? 'unset' : '100vh',
        backgroundColor: bgColor || 'transparent'
    }}>
        <div style={{
            flex: 1
        }}>
            {children}
        </div>

        <div style={{
            padding: '40px 0 50px 0',
            textAlign: 'center',
            fontSize: '12px',
            color: '#666',
            width: '100%'
        }}>Powered by <a href="https://www.gaxas.ai/" target="_blank" rel="noopener noreferrer" style={{
            color: '#666',
            textDecoration: 'underline',
        }}>Gaxas.ai</a></div>
    </div>
}

export default MainComponent;